import {SnackBarContextState, SnackBarContextAction, SnackBarContextActionType} from './types';

const reducer = (prevState: SnackBarContextState, action: SnackBarContextAction) => {
  switch (action.type) {
    case SnackBarContextActionType.SET_PUBLIC_TOAST_NOTIFICATION:
      return {
        ...prevState,
        publicToastNotification: action.toastNotification,
      };
    case SnackBarContextActionType.RESET_PUBLIC_TOAST_NOTIFICATION:
      return {
        ...prevState,
        publicToastNotification: action.toastNotification,
      };
    case SnackBarContextActionType.SET_OFFICE_TOAST_NOTIFICATION:
      return {
        ...prevState,
        officeToastNotification: action.toastNotification,
      };
    case SnackBarContextActionType.RESET_OFFICE_TOAST_NOTIFICATION:
      return {
        ...prevState,
        officeToastNotification: action.toastNotification,
      };
    case SnackBarContextActionType.SET_DAILY_CARE_LOG_TOAST_NOTIFICATION:
      return {
        ...prevState,
        dailyCareLogToastNotification: action.toastNotification,
      };
    case SnackBarContextActionType.RESET_DAILY_CARE_LOG_TOAST_NOTIFICATION:
      return {
        ...prevState,
        dailyCareLogToastNotification: action.toastNotification,
      };
  }
};
export default reducer;
